var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.72,329.7a91.82,91.82,0,0,0,52.91,71.78c60.92,27.58,167.92,71.64,206.16,59.79C373.49,444.33,485.66,132,467.35,75.88S72.48,57.7,55.64,104C42.78,139.38,50.13,256.84,59.72,329.7Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.72,329.7a91.82,91.82,0,0,0,52.91,71.78c60.92,27.58,167.92,71.64,206.16,59.79C373.49,444.33,485.66,132,467.35,75.88S72.48,57.7,55.64,104C42.78,139.38,50.13,256.84,59.72,329.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.34,326.25h0a.09.09,0,0,0,0-.09s-.08,0-.09,0a93.55,93.55,0,0,0-4.92,15.4,145.86,145.86,0,0,0-2.71,16l-.38,4c-.06.67-.13,1.34-.18,2l-.11,2c-.06,1.35-.14,2.7-.18,4.05l0,4.06.05,2c0,.67.08,1.35.12,2,.11,1.35.19,2.7.31,4,.26,2.69.66,5.36,1.08,8a.09.09,0,0,0,.07.06.07.07,0,0,0,.07-.07h0c0-1.35-.06-2.69-.09-4s-.16-2.68-.14-4,0-2.68,0-4l0-2,0-2,0-4,.11-4,0-2c0-.67.08-1.34.12-2l.24-4A143.06,143.06,0,0,1,415,341.74,91.61,91.61,0,0,1,419.34,326.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.91,347.26a.07.07,0,0,0,0-.08.06.06,0,0,0-.09,0,94.16,94.16,0,0,0-2.86,10.21,92.39,92.39,0,0,0-1.69,10.49c-.36,3.51-.75,7-.8,10.57a87.34,87.34,0,0,0,.37,10.6.08.08,0,0,0,.15,0c.4-3.52.65-7,.9-10.54s.28-7,.51-10.54a94.55,94.55,0,0,1,1.25-10.45A96.23,96.23,0,0,1,419.91,347.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.56,354.66a.07.07,0,0,0-.1,0,36,36,0,0,0-7.79,6.8,31.94,31.94,0,0,0-3,4.23l-.63,1.18-.49,1.23c-.17.41-.3.83-.43,1.25s-.26.83-.38,1.25a50.69,50.69,0,0,0-1.61,10.28,59.64,59.64,0,0,0,.39,10.35.07.07,0,0,0,.07.06.08.08,0,0,0,.07-.07l.89-10.24a89.07,89.07,0,0,1,1.3-10.1c.09-.42.21-.82.31-1.23a11.16,11.16,0,0,1,.36-1.2l.42-1.19.53-1.12a31.63,31.63,0,0,1,2.79-4.24,35.25,35.25,0,0,1,7.32-7.11h0A.07.07,0,0,0,431.56,354.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.92,367.82a11.44,11.44,0,0,0-3.54,4.26,24.94,24.94,0,0,0-2,5.22c-.14.44-.25.89-.35,1.35l-.32,1.36a23.56,23.56,0,0,0-.35,2.77c0,.93,0,1.86,0,2.78a25.91,25.91,0,0,0,.36,2.77.09.09,0,0,0,.06.06.08.08,0,0,0,.09-.06,26.36,26.36,0,0,0,.49-2.72c.14-.91.28-1.8.39-2.7s.25-1.78.32-2.68.19-1.8.38-2.68a24.28,24.28,0,0,1,1.52-5.16,11.35,11.35,0,0,1,3-4.45h0a.07.07,0,0,0-.09-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.58,378.08c-.38-4.54-1.13-9.05-1.84-13.55s-1.49-9-2.32-13.47-1.74-8.94-2.71-13.39a.06.06,0,0,0-.08-.05s-.06,0-.06.08q1.17,6.72,2.15,13.48t1.9,13.51c.55,4.51,1,9,1.55,13.54l1.67,13.54a.07.07,0,0,0,.06.07.08.08,0,0,0,.08-.07c0-1.14,0-2.28.08-3.43s-.05-2.28-.07-3.42C410,382.63,409.76,380.36,409.58,378.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,378c-.25-1.8-.58-3.59-.92-5.38L405.3,370c-.21-.88-.41-1.77-.67-2.64A74,74,0,0,0,401.16,357l-.55-1.25-.61-1.22c-.38-.83-.85-1.61-1.29-2.41a20.45,20.45,0,0,0-3.28-4.35.09.09,0,0,0-.1,0,.07.07,0,0,0,0,.1h0a20.1,20.1,0,0,1,3,4.45c.39.81.81,1.6,1.15,2.44L400,356l.48,1.26a74.37,74.37,0,0,1,3,10.35c.41,1.75.69,3.53,1,5.3l.42,2.66c.16.89.35,1.77.47,2.66.29,1.78.61,3.55.92,5.33s.61,3.57,1,5.35a.09.09,0,0,0,.07.06.07.07,0,0,0,.07-.07c0-1.82,0-3.64-.12-5.45S407.05,379.83,406.86,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.09,378.25c-.84-2.39-1.82-4.72-2.88-7a62.59,62.59,0,0,0-3.62-6.64.07.07,0,1,0-.12.07,63.76,63.76,0,0,1,3.09,6.85c.92,2.33,1.76,4.69,2.45,7.08s1.22,4.84,1.86,7.25,1.21,4.83,1.95,7.27a.08.08,0,0,0,.07.05.07.07,0,0,0,.07-.07,36.29,36.29,0,0,0-.7-7.57A47.55,47.55,0,0,0,403.09,378.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.94,386.2a16.23,16.23,0,0,0-2-4.2,17.52,17.52,0,0,0-2.91-3.62,13.83,13.83,0,0,0-1.85-1.4,7.72,7.72,0,0,0-2.11-1,.07.07,0,0,0-.08,0,.06.06,0,0,0,0,.09h0a10.35,10.35,0,0,1,3.48,2.71,16.08,16.08,0,0,1,2.43,3.68c.69,1.3,1.05,2.75,1.65,4.09.27.69.53,1.39.83,2.08a17.41,17.41,0,0,0,.92,2.1h0a.08.08,0,0,0,.06,0,.08.08,0,0,0,.08-.07,16.31,16.31,0,0,0-.09-2.32C403.28,387.71,403.12,387,402.94,386.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,344.18a13,13,0,0,1-9.18-9.74c-1.72-8,3.83-4.59-1.14-17.2s-3.82-15.48-2.1-19.11,2.67-2.49,4.2,2.29,7.07,12.23,9.17,26.18S403.22,344.18,403.22,344.18Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.93,330.61s-5-1.71-5.16-11.08,3.63-7.45,4.21-19.11,1.34-19.88,3.44-20.07,7.64,5.74,9.55,18.73-2.48,21.6-6.3,25.42S417.93,330.61,417.93,330.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.54,355.46s-1.14-6.88-3.44-10.13-7.26-6.12-10.51-12.42-6.88-9.37-6.69-.38,4.21,13.57,9.18,16.62S400.54,355.46,400.54,355.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.44,367.31A68.89,68.89,0,0,0,387.16,352c-6.68-6.5-12-9.75-10.12-6.5s4.2,3.06,7.45,8.79,2.29,9.94,6.88,13.19S398.44,367.31,398.44,367.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.87,378.58c-.19-.57-.39-4.77-6.88-8.21s-12.62-2.11-11.85-.39,4.78,4.59,8.79,6.31A40.42,40.42,0,0,0,397.87,378.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.55,355.84s-2.87-3.63-1.34-11.27,5-5.74,8.79-9.75,3.06-4.59,6.88-8.79,7.27-6.5,8.8-4.78-.77,7.07-3.06,10.13-5.93,4.59-7.65,8.41-1,9.94-5.35,12.8S417.55,355.84,417.55,355.84Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.11,357.94S434,350.11,439,344.38s6.88-10.13,7.07-6.31,1.72,6.88-2.3,11.85S427.11,357.94,427.11,357.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.48,370.56s-.2-3.06,10.7-10.13,15.48-8.41,14.33-5.54-5.92,5.73-11.08,10.89S423.48,370.56,423.48,370.56Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.67,343.37s-2.55-13.71-5.23-23.46-4.4-15.67-4.4-15.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.49,330.76s4.65-14.86,6.18-23.84-.19-15.67-1-19.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.94,355.17a72.57,72.57,0,0,0-7-10c-4.21-5-7.46-7.64-9.37-12.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.55,355.84s1.53-9.17,5.16-13.95,10.89-12.23,13.76-17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.42,378.38s-6.43-4.19-11-6.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.24,416.9c-.43-11.6-13.32-19.33-13.32-19.33H401.18s-12.89,7.73-13.32,19.33S402.46,471,402.46,471h17.18S434.67,428.49,434.24,416.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.47 386.17 398.27 386.17 401.18 397.57 420.56 397.57 423.47 386.17",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-65"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.06,423.79l15.4,1.77,3.46-15.16-14.18-4.93a33.07,33.07,0,0,0-2.2-10.71l10.55-10.52-9.69-12.16-12.32,7.78a33.35,33.35,0,0,0-10.16-5l-1.61-14.52H296.76l-1.61,14.52a33.12,33.12,0,0,0-10,4.92l-12.56-7.93L262.86,384l10.71,10.67A32.92,32.92,0,0,0,271.35,405l-14.59,5.07,3.46,15.17,15.6-1.79a33.45,33.45,0,0,0,6.3,7.8l-5.29,15,14,6.75,8.44-13.49a32.91,32.91,0,0,0,9.89.09l8.47,13.54,14-6.75-5.19-14.73A33.25,33.25,0,0,0,333.06,423.79Zm-49.59-17.05a21.07,21.07,0,1,1,21.07,21.06A21.07,21.07,0,0,1,283.47,406.74Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,398.91l10.74,1.23,2.41-10.57-9.89-3.43a23,23,0,0,0-1.53-7.46l7.35-7.33-6.75-8.47-8.59,5.41a22.87,22.87,0,0,0-7.07-3.48l-1.12-10.12H217.73l-1.12,10.12a23,23,0,0,0-7,3.42l-8.75-5.52-6.76,8.47,7.47,7.43a23.1,23.1,0,0,0-1.56,7.22l-10.16,3.53,2.42,10.56,10.87-1.24a23,23,0,0,0,4.38,5.43l-3.69,10.47,9.77,4.7,5.88-9.4a23.17,23.17,0,0,0,3.66.3,24.56,24.56,0,0,0,3.23-.23l5.9,9.43,9.76-4.7-3.61-10.27A23.33,23.33,0,0,0,243,398.91ZM208.47,387a14.68,14.68,0,1,1,14.68,14.68A14.68,14.68,0,0,1,208.47,387Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-65"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 269.48,
    cy: 309.76,
    r: 28.8,
    transform: "translate(-140.1 281.28) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.82,330.32v-3.85c-2.85-.11-5-1-6.38-2.73s-2.16-4.26-2.27-7.66l5.83-1a16.93,16.93,0,0,0,.44,3.45,4.2,4.2,0,0,0,1.05,2.07,2.5,2.5,0,0,0,1.82.69,1.86,1.86,0,0,0,1.76-.83,3.74,3.74,0,0,0,.48-1.91,6.12,6.12,0,0,0-1-3.53,14.51,14.51,0,0,0-2.66-2.88l-3.52-3a22.71,22.71,0,0,1-2.15-2.28,9,9,0,0,1-1.51-2.64,9.89,9.89,0,0,1-.56-3.52,8.08,8.08,0,0,1,2.21-6.06,9.23,9.23,0,0,1,5.94-2.47v-3.68h2v3.68a7.75,7.75,0,0,1,3.66,1,6.17,6.17,0,0,1,2.17,2.23,10.65,10.65,0,0,1,1.08,2.94,21.56,21.56,0,0,1,.41,3.08l-5.92.87a18.85,18.85,0,0,0-.25-2.71,4,4,0,0,0-.74-1.84,1.91,1.91,0,0,0-1.66-.62,2.11,2.11,0,0,0-1.76.91,3.36,3.36,0,0,0-.6,1.95,4.83,4.83,0,0,0,.92,3.06,19.37,19.37,0,0,0,2.06,2.23l3.44,3a22.92,22.92,0,0,1,2.52,2.69,12.85,12.85,0,0,1,1.87,3.21,10.94,10.94,0,0,1,.7,4,8.89,8.89,0,0,1-.89,4,7.33,7.33,0,0,1-2.57,2.92,8.29,8.29,0,0,1-3.95,1.33v3.89Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 394.59,
    cy: 252.41,
    r: 18.63,
    transform: "translate(-47.73 98.25) rotate(-13.39)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.8,265.71v-2.49a5.33,5.33,0,0,1-4.12-1.76,8.11,8.11,0,0,1-1.47-5l3.77-.64a10.83,10.83,0,0,0,.29,2.24,2.69,2.69,0,0,0,.68,1.33,1.59,1.59,0,0,0,1.18.45,1.18,1.18,0,0,0,1.13-.54,2.39,2.39,0,0,0,.31-1.23,4,4,0,0,0-.63-2.29,9.41,9.41,0,0,0-1.72-1.86l-2.28-2a15.8,15.8,0,0,1-1.39-1.48,6,6,0,0,1-1-1.71,6.49,6.49,0,0,1-.36-2.28,5.27,5.27,0,0,1,1.43-3.92,6,6,0,0,1,3.84-1.59v-2.38h1.29V241a4.87,4.87,0,0,1,2.37.66,3.93,3.93,0,0,1,1.4,1.44,6.64,6.64,0,0,1,.7,1.9,14.49,14.49,0,0,1,.27,2l-3.83.56a12.47,12.47,0,0,0-.16-1.76,2.66,2.66,0,0,0-.48-1.19,1.25,1.25,0,0,0-1.07-.4,1.38,1.38,0,0,0-1.14.59,2.16,2.16,0,0,0-.39,1.26,3.13,3.13,0,0,0,.59,2,12.86,12.86,0,0,0,1.34,1.45l2.22,1.92a15.76,15.76,0,0,1,1.63,1.74,8.45,8.45,0,0,1,1.21,2.08,7.07,7.07,0,0,1,.45,2.61,5.78,5.78,0,0,1-.57,2.58,4.81,4.81,0,0,1-1.66,1.89,5.49,5.49,0,0,1-2.56.86v2.51Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-65"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.36,88.84H425.81V67a22.57,22.57,0,1,0,22.57,22.57C448.38,89.34,448.37,89.09,448.36,88.84Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.58,86.62H428V64.79A22.56,22.56,0,0,1,450.58,86.62Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-65"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.66,
    y: 76.85,
    width: 16.63,
    height: 51.33,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.07,
    y: 94.93,
    width: 16.63,
    height: 33.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.49,
    y: 106.86,
    width: 16.63,
    height: 21.33,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,103.48l-3-15-3.13,2.76-16.72-19a3.43,3.43,0,0,0-1.71-1.07l-31-8.39-1.83,6.75,30,8.12,16,18.17-3.14,2.76Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Levels--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.36,
    y: 29.04,
    width: 95.43,
    height: 93.99,
    rx: 9.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.86,219.65H167.31a136.78,136.78,0,0,1,273.55,0Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.05,219.65H174.12a130,130,0,0,1,259.93,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.25,114.3,304.59,219.65l-.5.7-.5-.7L228.93,114.31a130,130,0,0,1,150.32,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.31,219.65H252.86a51.23,51.23,0,0,1,102.45,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94,253.35h0a6,6,0,0,1-8.5.6L230.27,161.59l5.23-6.06,106.78,89.32A6,6,0,0,1,342.94,253.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.08,
    cy: 220.35,
    r: 29.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.08,
    cy: 220.35,
    r: 15.85,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.28
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201,190.65V172h3.41v16.31H209v2.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.57,190.91a5.87,5.87,0,0,1-3.15-.74,4.07,4.07,0,0,1-1.69-2.12,9.69,9.69,0,0,1-.5-3.27v-7a9.41,9.41,0,0,1,.5-3.23,3.93,3.93,0,0,1,1.69-2.06,7.34,7.34,0,0,1,6.34,0,4,4,0,0,1,1.68,2.06,8.93,8.93,0,0,1,.52,3.23v7a9,9,0,0,1-.52,3.23,4.18,4.18,0,0,1-1.68,2.12A5.84,5.84,0,0,1,215.57,190.91Zm0-2.51a1.81,1.81,0,0,0,1.26-.37,1.9,1.9,0,0,0,.54-1,6.88,6.88,0,0,0,.14-1.41V177a6.57,6.57,0,0,0-.14-1.4,1.81,1.81,0,0,0-.54-1,1.86,1.86,0,0,0-1.26-.36,1.81,1.81,0,0,0-1.22.36,1.7,1.7,0,0,0-.55,1,6.57,6.57,0,0,0-.14,1.4v8.59a6.9,6.9,0,0,0,.13,1.41,1.72,1.72,0,0,0,.54,1A1.79,1.79,0,0,0,215.57,188.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.43,190.65,222.78,172h2.85l1.55,12.09,1.93-12h2.33l2,12L234.94,172h2.81l-2.6,18.65h-2.77l-2.07-12.5-2.05,12.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.28
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M367,190.65V172h3.38v7.81h3.8V172h3.41v18.65h-3.41v-8.42h-3.8v8.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M380.55,190.65V172h3.36v18.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.46,190.91a4.91,4.91,0,0,1-2.92-.78A4.4,4.4,0,0,1,387,187.9a11.06,11.06,0,0,1-.47-3.39v-6.27a11.67,11.67,0,0,1,.46-3.45,4,4,0,0,1,1.63-2.22,5.68,5.68,0,0,1,3.21-.78,6.13,6.13,0,0,1,3,.65,3.71,3.71,0,0,1,1.62,1.85,7.79,7.79,0,0,1,.5,2.94v1h-3.25v-1.06a7.73,7.73,0,0,0-.13-1.55,1.7,1.7,0,0,0-.5-1,1.88,1.88,0,0,0-1.23-.33,1.72,1.72,0,0,0-1.31.44,2.14,2.14,0,0,0-.5,1.15,10.84,10.84,0,0,0-.11,1.57v7.8a7.43,7.43,0,0,0,.17,1.68,2,2,0,0,0,.59,1.1,1.89,1.89,0,0,0,1.25.38,1.74,1.74,0,0,0,1.26-.42,2.13,2.13,0,0,0,.61-1.15,7.42,7.42,0,0,0,.18-1.75v-1.75h-2v-2.14h5.07v9.46h-2.19l-.25-1.84a3.55,3.55,0,0,1-1.12,1.51A3.23,3.23,0,0,1,391.46,190.91Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M399.71,190.65V172h3.38v7.81h3.8V172h3.41v18.65h-3.41v-8.42h-3.8v8.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.28
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M269.88,130.12l.33-18.66h3.52l2.65,12.92,2.76-12.92h3.41l.35,18.66h-2.54l-.27-13-2.65,13h-2.05l-2.7-13-.25,13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M285.52,130.12V111.46h7.83v2.4h-4.42v5.37h3.48v2.37h-3.48v6.17h4.47v2.35Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.38,130.12V111.46h4.4a8.15,8.15,0,0,1,3.55.63,3.58,3.58,0,0,1,1.82,1.91,8.53,8.53,0,0,1,.54,3.27v6.81a9.14,9.14,0,0,1-.54,3.38,3.78,3.78,0,0,1-1.79,2,7.51,7.51,0,0,1-3.45.66Zm3.41-2.37h1a2.61,2.61,0,0,0,1.68-.42,1.83,1.83,0,0,0,.63-1.21,15.08,15.08,0,0,0,.11-1.94V117a8.16,8.16,0,0,0-.16-1.82,1.59,1.59,0,0,0-.67-1,3.2,3.2,0,0,0-1.63-.32h-1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.3,130.12V111.46h3.36v18.66Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M319.65,130.37a5.77,5.77,0,0,1-3.22-.76,3.86,3.86,0,0,1-1.59-2.16,11.48,11.48,0,0,1-.44-3.37V111.46h3.32v13a10.66,10.66,0,0,0,.11,1.64,2.39,2.39,0,0,0,.54,1.25,1.66,1.66,0,0,0,1.28.47,1.64,1.64,0,0,0,1.3-.47,2.47,2.47,0,0,0,.53-1.25,9.48,9.48,0,0,0,.13-1.64v-13h3.29v12.62a11.48,11.48,0,0,1-.44,3.37,3.87,3.87,0,0,1-1.57,2.16A5.79,5.79,0,0,1,319.65,130.37Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M327.53,130.12l.32-18.66h3.52L334,124.38l2.76-12.92h3.41l.35,18.66H338l-.27-13-2.65,13H333l-2.69-13-.26,13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M273.48,69.76V40.48h7a15.45,15.45,0,0,1,5,.71,5.76,5.76,0,0,1,3.11,2.4,8.67,8.67,0,0,1,1.07,4.63,14,14,0,0,1-.33,3.18,6,6,0,0,1-1.1,2.4,5,5,0,0,1-2.15,1.54l4.08,14.42h-5.35l-3.54-13.41h-2.46V69.76ZM278.83,53h1.66a5.7,5.7,0,0,0,2.48-.45,2.69,2.69,0,0,0,1.32-1.45,7,7,0,0,0,.4-2.55,5.51,5.51,0,0,0-.82-3.31c-.54-.73-1.57-1.1-3.09-1.1h-1.95Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.83,69.76V40.48h5.28V69.76Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,70.16a8.62,8.62,0,0,1-4.41-1,6.47,6.47,0,0,1-2.67-3,12.74,12.74,0,0,1-1-4.88l4.59-.9a13.67,13.67,0,0,0,.41,3,4.37,4.37,0,0,0,1,2,2.52,2.52,0,0,0,1.86.71,2.11,2.11,0,0,0,1.85-.78,3.37,3.37,0,0,0,.54-2,5.3,5.3,0,0,0-.87-3.14A13.71,13.71,0,0,0,310,57.69l-3.69-3.26a11,11,0,0,1-2.48-3,8.24,8.24,0,0,1-.92-4.06A6.93,6.93,0,0,1,305,42a7.76,7.76,0,0,1,5.53-1.88,8.24,8.24,0,0,1,3.43.63,5.46,5.46,0,0,1,2.19,1.75,8.11,8.11,0,0,1,1.21,2.55,15.24,15.24,0,0,1,.5,3l-4.55.79a15.27,15.27,0,0,0-.31-2.45,3.32,3.32,0,0,0-.83-1.7,2.33,2.33,0,0,0-1.75-.62,2.21,2.21,0,0,0-1.83.78,3,3,0,0,0-.63,1.93,4.41,4.41,0,0,0,.61,2.44,9.23,9.23,0,0,0,1.78,2L314,54.47A15.33,15.33,0,0,1,317.06,58,9.15,9.15,0,0,1,318.34,63a7.49,7.49,0,0,1-.92,3.72,6.7,6.7,0,0,1-2.57,2.55A7.8,7.8,0,0,1,311,70.16Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.2,69.76V40.48h5.35V53.35l5.78-12.87h5.1l-5.61,13.09L338,69.76h-5.32l-4.91-13.34-1.23,2.24v11.1Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.58,230.63c5.21-6.42,9.87-2.65,15.08-9.07s.55-10.21,5.76-16.64,9.87-2.64,15.08-9.07.55-10.21,5.76-16.64,9.88-2.65,15.09-9.08",
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.47,239.46c5.21-6.42,9.87-2.64,15.08-9.07s.55-10.21,5.76-16.63,9.87-2.65,15.09-9.08.55-10.21,5.76-16.64,9.87-2.65,15.08-9.08",
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.37,248.29c5.21-6.42,9.87-2.64,15.08-9.07s.55-10.2,5.76-16.63,9.87-2.65,15.08-9.08.55-10.21,5.76-16.64,9.87-2.65,15.09-9.07",
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.26,257.13c5.21-6.43,9.87-2.65,15.08-9.08s.55-10.2,5.76-16.63,9.87-2.65,15.08-9.08.55-10.2,5.77-16.63,9.87-2.65,15.08-9.08",
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-65"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 31.97,
    y1: 471.01,
    x2: 470.37,
    y2: 471.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.68,448.12s-1.15,17,.19,20.44,6.11,8.78,9,7.64,2.1-7.84,2.1-12.42,1.15-11.46,1.15-12.6S53.68,448.12,53.68,448.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,459.58s-.38,11.65,1.72,12.41,14.13-.57,16.23-.19,8.79.77,11.27,0,5.73-2.1,4.77-4-13.17-7.06-15.85-8.78-7.45-5-7.45-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.89,317.87s-1,6.69-1.34,18.34,3.63,35.9,3.63,35.9l-5,28.27-19.1,43.54s-4.58,1.15-3.43,4.2,5.15,6.3,7.44,6.3,5.35-.95,6.31-2.48,1.33-5.35,1.33-5.35,33.23-44.3,33.81-45.83,5.92-25,5.92-25l13.75,18.52,19.1,57.11a4.82,4.82,0,0,0-.58,4.2c.77,2.48,2.1,5.92,2.1,5.92a17.26,17.26,0,0,0,5.16-1.15,23.57,23.57,0,0,0,6.49-4,5.76,5.76,0,0,0,.39-3.43c-.39-1.91-1.53-2.68-1.34-4.21s-6.69-55.95-7.83-59.58-27.5-58.25-27.5-58.25l-1.91-13.94A62.3,62.3,0,0,1,78.89,317.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.63,199S98.09,196,92,197.57,76.4,207.5,77.09,212.42,89,228.09,89,228.09l-.43,9.82,19.53,8.43,2.78-12.55s7.17-1.83,6.9-2.9-1.92-10.83-1.92-10.83a2.73,2.73,0,0,0,.71-3.86,49.91,49.91,0,0,0-4.64-5.94S112.89,206.19,105.63,199Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,233.79s-4.59,0-5.35-.13a57.3,57.3,0,0,1-5.43-2.87L108.53,243Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,212.77c.48.76.62,1.53.31,1.72s-1-.25-1.43-1-.62-1.52-.31-1.72S110.29,212,110.77,212.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15,209.25a2.34,2.34,0,0,0-2.7,1.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,223a5.09,5.09,0,0,1-3.81-.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.92,200.68l-8,4.17s3.07,2.05,2.41,3.91l-.65,1.87.17,7.31-2.06.81s-6.21-4.35-7.72-.29,3.76,7,3.76,7-2.17,4.8-4.16,5.87-.87-2.32-4.8-3.3-11.35-7.86-11.51-11.78,1.8-12.91,8.43-16.87S94,194.5,97.75,194.68s7.42-2,8.63.56A9.31,9.31,0,0,1,106.92,200.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,237.85A67.05,67.05,0,0,0,77,259.62c-2.87,12-3.44,26.36-1,33.61s2.1,20.06,2.1,20.06-1.91,3.63.19,5.92,15.47,6.49,27.12,4.77,12-4.58,12.61-6.49.38-27.88-2.1-39.53A276.77,276.77,0,0,0,108.87,251C107.15,245.87,87.1,237.85,87.1,237.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.35 231.44 111.54 247.4 111.16 255.99 84.81 238.23 87.35 231.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.68,265.32l-12.73-11-4.32-2.55-26.8,48c-8.31,9.8-21.54,12.23-29.56,5.43s-7.78-20.25.53-30.05l40.12-37.64L167.07,227.1l-5.2-3.12-41,43.47a37.71,37.71,0,1,0,57.52,48.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.95 254.31 194.63 251.76 180.83 276.5 192.65 286.32 196.28 288.87 211.68 265.32 198.95 254.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.85 254.25 157.96 257.2 178.92 237.54 167.07 227.1 161.87 223.98 148.45 238.21 154.85 254.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.89,263l-13.26-11.25-30.58,45.73c-8.31,9.8-21.55,12.23-29.57,5.43s-7.78-20.26.53-30.06l40.13-37.63L161.87,224l-44.8,41.16a37.72,37.72,0,0,0,57.53,48.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.65 286.32 207.89 263.01 194.63 251.76 179.17 274.88 192.65 286.32",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.85 254.25 175.14 235.23 161.87 223.98 141.37 242.82 154.85 254.25",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.06,300.49l41.44,20.63a42.64,42.64,0,0,0,4.78-4.59,6.17,6.17,0,0,1,4.58-2.67c1.72-.19,2.87.57,5-1.14s2.48-1.34,1.72.57-1,2.67-2.68,2.86a6.9,6.9,0,0,0-2.86,1s5,3.05,6.11,3.63,2.1,1.52,1.72,2.1,0,1.52-1.15,1.52h-2.48a28.34,28.34,0,0,0-3.06,3.25c-1.52,1.91-3.05,2.87-4.77,3.06a32.47,32.47,0,0,1-10.31-1.15c-4-1.14-37.25-11.46-41.64-13.18a56.58,56.58,0,0,1-9.93-5.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.28,253.7s-5.54,4.39-5,10.12,11.08,44.31,11.08,44.31l18.91-11.65s-5.92-32.27-9.36-37.81-7.45-6.5-7.45-6.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,291.13,86,305.08s2.29,8,4,9.35l1.72,1.34s18.34-12.6,19.48-14.32S108.87,292.09,108.3,291.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.73,
    y: 260,
    width: 3.25,
    height: 7.45,
    rx: 1.38,
    transform: "translate(-136.99 161.68) rotate(-41.06)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.37,
    y: 263.23,
    width: 3.25,
    height: 6.31,
    rx: 1.38,
    transform: "translate(-139.3 160.75) rotate(-41.06)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.8,
    y: 265.81,
    width: 3.25,
    height: 6.31,
    rx: 1.38,
    transform: "translate(-141.63 159.69) rotate(-41.06)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.99,
    y: 268.17,
    width: 3.25,
    height: 5.52,
    rx: 1.38,
    transform: "translate(-143.61 158.33) rotate(-41.06)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.17c27045597d90cacdf0f8beaa8524ac.svg";
export { ForwardRef as ReactComponent };